import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect as connectR } from 'react-redux';
import { Col, FormControl, Row } from 'react-bootstrap';
import _ from 'lodash';
import ValidatorFormGroup from '../../main/validator-form-group';
import translate from '../../translate';
import { INTERNAL_PARTNER_MANAGER } from '../../../util/common';
import { BookingLogicPolicy } from '../../../store/locationsSlice';
import { PARTNER_MANAGER_CONTROL } from '../../../util/enums';
import { Combobox } from 'react-widgets';
import memoize from 'memoize-one';

export const FIELD_BOOKING_LOGIC = 'booking_logic';
export const FIELD_BOOKING_MINUTES = 'booking_minutes';
export const FIELD_GATEWAY_SERIALNUMBER = 'gateway_serial_number';

function getOtherLocationWithName(locations, name, thisLocationId) {
    return _.find(
        locations,
        (location) => location.name == name && location.id != thisLocationId
    );
}

const VALIDATORS = {
    name: {
        isValid: (value, thisLocationId, locations) => {
            const nameIsValid =
                `${value}`.replace(/\s/, '').length > 1 &&
                `${value}`.length < 63;
            const otherLocationWithSameName =
                getOtherLocationWithName(locations, value, thisLocationId) !=
                null;
            return nameIsValid && !otherLocationWithSameName;
        },
    },
    num_of_appartments: { isValid: (value) => /^[0-9]{0,5}$/.test(`${value}`) },
    [FIELD_GATEWAY_SERIALNUMBER]: {
        isValid: (value) => /^[a-zA-Z0-9]{0,20}$/.test(value),
    },
};

const PICKUP_MINUTES_LIST = [5, 10, 15, 20];
const RESERVATION_MINUTES_LIST = [5, 10, 15, 20];
const BOOKING_MINUTES_LIST = [10, 30, 40, 50, 60];

const BOOKING_LOGIC_EXTERNAL = [
    BookingLogicPolicy.USER_DIRECT_BOOKING,
    BookingLogicPolicy.APPLIANCE_START,
];
const BOOKING_LOGIC_INTERNAL = [
    ...BOOKING_LOGIC_EXTERNAL,
    BookingLogicPolicy.CALENDAR,
];
const BOOKING_LOGIC_WITH_BOOKING_TIME = [
    BookingLogicPolicy.USER_DIRECT_BOOKING,
    BookingLogicPolicy.CALENDAR,
];

const LocationBasicForm = createReactClass({
    displayName: 'LocationBasicForm',

    propTypes: {
        info: PropTypes.shape({
            name: PropTypes.string,
            num_of_appartments: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            reservation_minutes: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            pickup_minutes: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            [FIELD_BOOKING_MINUTES]: PropTypes.number,
            [FIELD_BOOKING_LOGIC]: PropTypes.oneOf(
                Object.values(BookingLogicPolicy)
            ),
        }),
        handleChange: PropTypes.func.isRequired,
        mansionId: PropTypes.number.isRequired,
        forceValidation: PropTypes.bool,
        disabled: PropTypes.bool,
        strings: PropTypes.object,
        locationsByMansionsById: PropTypes.shape({}).isRequired,
        serialNumbers: PropTypes.arrayOf(
            PropTypes.shape({
                number: PropTypes.string,
                type: PropTypes.string,
                connected: PropTypes.bool,
            })
        ).isRequired,
        partnerManagerDetails: PropTypes.shape({
            control: PropTypes.oneOf(Object.values(PARTNER_MANAGER_CONTROL)),
        }),
    },
    defaultProps: {
        info: {},
        disabled: false,
        forceValidation: false,
        strings: {
            name: 'Bezeichnung des Waschraums',
            num_of_appartments:
                'Wieviele Wohneinheiten können diesen Waschraum nutzen',
            reservation_minutes: 'Reservierungszeit',
            pickup_minutes: 'Abholzeit',
        },
    },
    getInitialState() {
        return _.extend(
            {
                id: null,
                name: '',
                num_of_appartments: '',
                reservation_minutes: 10,
                pickup_minutes: 10,
                [FIELD_BOOKING_MINUTES]: 40,
                [FIELD_BOOKING_LOGIC]: BookingLogicPolicy.APPLIANCE_START,
                _dirty: {},
                _valid: true,
            },
            this.props.info
        );
    },

    componentWillReceiveProps(nextProps) {
        function filterValueToAllowed(field, allowedValues) {
            if (!nextProps.info) {
                return allowedValues[0];
            }
            if (!allowedValues.includes(nextProps.info[field])) {
                return allowedValues[0];
            } else {
                return nextProps.info[field];
            }
        }

        const moddedInfo = _.cloneDeep(nextProps.info) || {};
        if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
            if (!nextProps.disabled) {
                moddedInfo.reservation_minutes = filterValueToAllowed(
                    'reservation_minutes',
                    RESERVATION_MINUTES_LIST
                );
                moddedInfo.pickup_minutes = filterValueToAllowed(
                    'pickup_minutes',
                    PICKUP_MINUTES_LIST
                );
                moddedInfo[FIELD_BOOKING_MINUTES] = filterValueToAllowed(
                    FIELD_BOOKING_MINUTES,
                    BOOKING_MINUTES_LIST
                );
            }
            this.setState(moddedInfo, this._persistState);
        }
    },

    _persistState() {
        const new_state = {};
        _.each(
            [
                'id',
                'name',
                'num_of_appartments',
                'reservation_minutes',
                'pickup_minutes',
                FIELD_BOOKING_MINUTES,
                FIELD_BOOKING_LOGIC,
                FIELD_GATEWAY_SERIALNUMBER,
            ],
            (fieldName) => {
                new_state[fieldName] = this.state[fieldName];
            }
        );
        // return valid state to parent
        new_state._valid = Object.keys(VALIDATORS).reduce(
            (formValid, fieldName) => {
                return (
                    formValid &&
                    VALIDATORS[fieldName].isValid(new_state[fieldName])
                );
            },
            true
        );
        this.props.handleChange(new_state);
    },

    _markDirty(key) {
        const newDirt = {};
        newDirt[key] = true;
        const newState = _.extend({}, this.state, {
            _dirty: _.extend({}, this.state._dirty, newDirt),
        });
        this.setState(newState);
    },

    _handleFormChange(key, value) {
        this._markDirty(key);
        const newSt = _.set({}, key, value);
        newSt[key] = value;
        this.setState(newSt, this._persistState);
    },

    _getSerialNumbers: memoize((serialNumbers, locations, locationId) => {
        if (!serialNumbers) {
            return [];
        }
        if (!locations) {
            return serialNumbers;
        }
        const location = Object.values(locations).find(
            (it) => it.id === locationId
        );
        if (!location) {
            return serialNumbers;
        }
        const locationSerialNumber = location.serial_number;
        const knownNumber = serialNumbers.some(
            (it) => it.number === locationSerialNumber
        );
        if (knownNumber) {
            return serialNumbers;
        } else {
            return [
                {
                    number: locationSerialNumber,
                    type: 'HUB',
                    connected: false,
                },
                ...serialNumbers,
            ];
        }
    }),

    renderValidatorGroupForMinutes(field, label, timeOptions) {
        const currentValue = this.state[field];
        return (
            <ValidatorFormGroup label={label}>
                <select
                    className="form-control"
                    name={field}
                    onChange={(event) => {
                        this._handleFormChange(
                            field,
                            parseInt(event.target.value, 10)
                        );
                    }}
                    value={currentValue}
                    disabled={this.props.disabled}
                    required={this.props.disabled}
                >
                    {_.map(timeOptions, (id) => (
                        <option key={id} value={id}>
                            {id + this.props.strings.minutes}
                        </option>
                    ))}
                    {!timeOptions.includes(currentValue) && (
                        <option key={currentValue} value={currentValue}>
                            {currentValue + this.props.strings.minutes}
                        </option>
                    )}
                </select>
            </ValidatorFormGroup>
        );
    },

    renderReservationTime() {
        return this.renderValidatorGroupForMinutes(
            'reservation_minutes',
            this.props.strings.reservation_minutes,
            RESERVATION_MINUTES_LIST
        );
    },

    renderBookingTime() {
        return this.renderValidatorGroupForMinutes(
            FIELD_BOOKING_MINUTES,
            this.props.strings.booking_minutes,
            BOOKING_MINUTES_LIST
        );
    },

    renderPickupTime() {
        return this.renderValidatorGroupForMinutes(
            'pickup_minutes',
            this.props.strings.pickup_minutes,
            PICKUP_MINUTES_LIST
        );
    },

    renderBookingLogic() {
        const partnerManagerControl = this.props.partnerManagerDetails?.control;
        const isAdmin = PARTNER_MANAGER_CONTROL.ADMIN === partnerManagerControl;
        const availableLogics = isAdmin
            ? BOOKING_LOGIC_INTERNAL
            : BOOKING_LOGIC_EXTERNAL;

        return (
            <ValidatorFormGroup label={this.props.strings.booking_logic}>
                <select
                    className="form-control"
                    name={FIELD_BOOKING_LOGIC}
                    onChange={(event) => {
                        this._handleFormChange(
                            FIELD_BOOKING_LOGIC,
                            event.target.value
                        );
                    }}
                    value={this.state[FIELD_BOOKING_LOGIC]}
                    disabled={this.props.disabled}
                    required={this.props.disabled}
                >
                    {_.map(availableLogics, (id) => (
                        <option key={id} value={id}>
                            {this.props.strings.bookingLogicEnum[id] || id}
                        </option>
                    ))}
                    {!availableLogics.includes(
                        this.state[FIELD_BOOKING_LOGIC]
                    ) && (
                        <option
                            key={this.state[FIELD_BOOKING_LOGIC]}
                            value={this.state[FIELD_BOOKING_LOGIC]}
                        >
                            {this.props.strings.bookingLogicEnum[
                                this.state[FIELD_BOOKING_LOGIC]
                            ] || this.state[FIELD_BOOKING_LOGIC]}
                        </option>
                    )}
                </select>
            </ValidatorFormGroup>
        );
    },

    renderBookingLogicSection() {
        const partnerManagerType = this.props.partnerManagerDetails?.type;
        const showSelection =
            INTERNAL_PARTNER_MANAGER.includes(partnerManagerType);
        const showBookingTime = BOOKING_LOGIC_WITH_BOOKING_TIME.includes(
            this.state[FIELD_BOOKING_LOGIC]
        );

        return [
            showSelection && this.renderBookingLogic(),
            <div id="bls1" key="bls1" className="static_label_container">
                <label htmlFor="">
                    {showBookingTime
                        ? this.props.strings.time_label_with_user_direct_booking
                        : this.props.strings.time_label}
                </label>
            </div>,
            <Row id="bls2" key="bls2">
                <Col xs={6} sm={6} md={6} lg={6}>
                    {this.renderReservationTime()}
                </Col>
                <Col xs={6} sm={6} md={6} lg={6}>
                    {this.renderPickupTime()}
                </Col>
            </Row>,
            showBookingTime && (
                <div id="bls3" className="static_label_container">
                    <label htmlFor="">
                        {this.props.strings.time_label_for_booking_time}
                    </label>
                </div>
            ),
            showBookingTime && (
                <Row id="bls4">
                    <Col xs={6} sm={6} md={6} lg={6}>
                        {this.renderBookingTime()}
                    </Col>
                </Row>
            ),
        ];
    },

    renderGatewaySection() {
        const serialNumbers = this._getSerialNumbers(
            this.props.serialNumbers,
            this.props.locationsByMansionsById[this.props.mansionId] ?? [],
            this.state.id
        );
        return (
            <ValidatorFormGroup
                key={'gw_dd'}
                label={
                    <>
                        {this.props.strings.gateway_serial_number_dropdown}{' '}
                        {!this.props.disabled && (
                            <span style={{ color: '#7D7D7C' }}>
                                {this.props.strings.optional}
                            </span>
                        )}
                    </>
                }
                errorLabel={
                    this.props.strings.gateway_serial_number_input_error
                }
                hideErrorLabel={
                    !(
                        this.state._dirty[FIELD_GATEWAY_SERIALNUMBER] ||
                        this.props.forceValidation
                    ) ||
                    VALIDATORS[FIELD_GATEWAY_SERIALNUMBER].isValid(
                        this.state[FIELD_GATEWAY_SERIALNUMBER]
                    )
                }
                helpLabel={this.props.strings.gateway_serial_number_help}
            >
                <Combobox
                    data={serialNumbers}
                    onChange={(value) =>
                        this._handleFormChange(
                            FIELD_GATEWAY_SERIALNUMBER,
                            typeof value === 'object' ? value.number : value
                        )
                    }
                    valueField="number"
                    textField="number"
                    value={this.state[FIELD_GATEWAY_SERIALNUMBER]}
                    disabled={this.props.disabled}
                />
            </ValidatorFormGroup>
        );
    },

    render() {
        const locations =
            this.props.locationsByMansionsById[this.props.mansionId] || [];
        let nameError = this.props.strings.name_error;
        if (
            getOtherLocationWithName(locations, this.state.name, this.state.id)
        ) {
            nameError = this.props.strings.name_duplicate_error;
        }

        return (
            <div>
                <ValidatorFormGroup
                    label={this.props.strings.name}
                    hideErrorLabel={
                        !(
                            this.state._dirty.name || this.props.forceValidation
                        ) ||
                        VALIDATORS.name.isValid(
                            this.state.name,
                            this.state.id,
                            locations
                        )
                    }
                    errorLabel={nameError}
                >
                    <FormControl
                        type="text"
                        className="input-text-color"
                        value={this.state.name}
                        name="name"
                        data-testid="location-name-input"
                        onChange={(event) => {
                            this._handleFormChange('name', event.target.value);
                        }}
                        required
                        disabled={this.props.disabled}
                    />
                </ValidatorFormGroup>

                <ValidatorFormGroup
                    label={this.props.strings.num_of_appartments}
                    hideErrorLabel={
                        !(
                            this.state._dirty.num_of_appartments ||
                            this.props.forceValidation
                        ) ||
                        VALIDATORS.num_of_appartments.isValid(
                            this.state.num_of_appartments
                        )
                    }
                    errorLabel={this.props.strings.num_of_appartments_error}
                >
                    <FormControl
                        type="text"
                        className="input-text-color"
                        value={this.state.num_of_appartments}
                        name="num_of_appartments"
                        data-testid="num_of_appartments-input"
                        onChange={(event) => {
                            this._handleFormChange(
                                'num_of_appartments',
                                event.target.value
                            );
                        }}
                        required
                        disabled={this.props.disabled}
                    />
                </ValidatorFormGroup>
                {this.renderBookingLogicSection()}
                {this.renderGatewaySection()}
            </div>
        );
    },
});

export default connectR(
    (store) => ({
        locationsByMansionsById: store.locations.locationsByMansionsById,
        serialNumbers: store.serialNumbers.routerSerialNumbers,
        partnerManagerDetails: store.partnerManager.partnerManagerDetails,
    }),
    {}
)(translate('LocationBasicForm')(LocationBasicForm));
